export function getdata(){
	var obj = {
		headDatas:[
			{
				title:'负债和所有者权益（或股东权益）',
				prop:'title',
				width: "120px",
				custom: true,
				
			},{
				title: "行次",
				prop: "grade",
				width: "50px",
				custom: true,
			},
			{
				title: "期末余额",
				custom: true,
				prop: "cwbbyzx_0_x_1",
				width: "100px",
				
			}, {
				title: "上年年末余额",
				prop: "cwbbyzx_0_x_2",
				width: "100px",
				custom: true,
				
			},
		],
		headData: [{
				title: "资产",
				prop: "title",
				width: "120px",
				custom: true,
				
			},{
				title: "行次",
				prop: "grade",
				width: "50px",
				custom: true,
			},
			{
				title: "期末余额",
				prop: "cwbbyzx_0_x_1",
				custom: true,
				width: "100px",
			},
			{
				title:'上年年末余额',
				prop:'cwbbyzx_0_x_2',
				width: "100px",
				 
				custom: true,
			},
			
		],
		tableDatas:[
			{
					title:'流动负债：',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_35_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_35_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
			
				},
				{
					title:'短期借款',
					grade:'35',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_35_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_35_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'交易性金融负债',
					grade:'36',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_36_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_36_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'衍生金融负债',
					grade:'37',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_37_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_37_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应付票据',
					grade:'38',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_38_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_38_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应付账款',
					grade:'39',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_39_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_39_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'预收款项',
					grade:'40',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_40_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_40_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'合同负债',
					grade:'41',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_41_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_41_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应付职工薪酬',
					grade:'42',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_42_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_42_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应交税费',
					grade:'43',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_43_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_43_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他应付款',
					grade:'44',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_44_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_44_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'持有待售负债',
					grade:'45',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_45_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_45_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'一年内到期的非流动负债',
					grade:'46',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_46_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_46_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他流动负债',
					grade:'47',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_47_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_47_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'流动负债合计',
					grade:'48',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_48_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_48_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'非流动负债:',
					grade:'',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellType:"1",
						cellVal:"240040043.08",
					},
					cwbbyzx_0_x_2: {
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'长期借款',
					grade:'49',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_49_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_49_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'应付债券',
					grade:'50',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_50_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_50_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其中：优先股',
					grade:'51',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_51_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_51_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'永续债',
					grade:'52',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_52_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_52_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'租赁负债',
					grade:'53',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_53_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_53_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'长期应付款',
					grade:'54',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_20_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'预计负债',
					grade:'55',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_21_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'递延收益',
					grade:'56',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_22_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'递延所得税负债',
					grade:'57',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_23_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_23_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他非流动负债',
					grade:'58',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_24_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_24_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'非流动负债合计',
					grade:'59',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_25_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_25_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'负债合计',
					grade:'60',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_26_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_26_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'所有者权益(或股东权益):',
					grade:'',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_27_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_27_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'实收资本（或股本）',
					grade:'61',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_28_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_28_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他权益工具',
					grade:'62',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_29_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_29_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其中：优先股',
					grade:'63',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_30_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_30_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'永续债',
					grade:'64',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_31_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_31_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'资本公积',
					grade:'65',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_32_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_32_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'减：库存股',
					grade:'66',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_33_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_33_2",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title:'其他综合收益',
					grade:'67',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
				},{
					title:'专项储备',
					grade:'68',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
				},{
					title:'盈余公积',
					grade:'69',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
				},{
					title:'未分配利润',
					grade:'70',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
				},{
					title:'所有者权益(或股东权益)合计',
					grade:'71',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
				},{
					title:'负债和所有者权益（或股东权益）总计',
					grade:'72',
					disabledcwbbyzx_0_x_1:false,
					disabledcwbbyzx_0_x_2:false,
					cwbbyzx_0_x_1: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
					cwbbyzx_0_x_2: {
						cellCode:"cwbbwxz_0_34_3",
						cellType:"0",
						cellVal:"240040043.08"
					},
				}
			
		],
		tableData: [{
				title: "流动资产：",
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_1_1",
					cellType:"1",
					cellVal:"240040043.08",
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_1_1",
					cellType:"1",
					cellVal:"240040043.08",
				},
	
			},
			{
				title: "货币资金",
				grade:'1',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_1_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_1_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "交易性金融资产",
				grade:'2',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_2_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_2_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "衍生金融资产",
				grade:'3',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_3_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_3_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "应收票据",
				grade:'4',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_4_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_4_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "应收账款",
				grade:'5',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_5_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_5_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "应收款项融资",
				grade:'6',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_6_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_6_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "预付款项",
				grade:'7',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_7_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_7_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他应收款",
				grade:'8',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_8_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_8_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "存货",
				grade:'9',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_9_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_9_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "合同资产",
				grade:'10',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_10_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_10_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "持有待售资产",
				grade:'11',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_11_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_11_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "一年内到期的非流动资产",
				grade:'12',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_12_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_12_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他流动资产",
				grade:'13',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_13_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_13_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "流动资产合计",
				grade:'14',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_14_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_14_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "非流动资产：",
				grade:'',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {cellType:"0",},
				cwbbyzx_0_x_2: {cellType:"0",},
			},{
				title: "债权投资",
				grade:'15',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_15_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_15_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他债权投资",
				grade:'16',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_16_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_16_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "长期应收款",
				grade:'17',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_17_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_17_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "长期股权投资",
				grade:'18',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_18_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_18_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他权益工具投资",
				grade:'19',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_19_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_19_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他非流动金融资产",
				grade:'20',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_20_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_20_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "投资性房地产",
				grade:'21',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_21_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_21_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "固定资产",
				grade:'22',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_22_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_22_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "在建工程",
				grade:'23',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_23_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_23_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "生产性生物资产",
				grade:'24',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_24_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_24_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "油气资产",
				grade:'25',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_25_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_25_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "使用权资产",
				grade:'26',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_26_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_26_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "无形资产",
				grade:'27',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_27_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_27_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "开发支出",
				grade:'28',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_28_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_28_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "商誉",
				grade:'29',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_29_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_29_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "长期待摊费用",
				grade:'30',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_30_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_30_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "递延所得税资产",
				grade:'31',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_31_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_31_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "其他非流动资产",
				grade:'32',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_32_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_32_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "非流动资产合计",
				grade:'33',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_33_1",
					cellType:"1",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_33_2",
					cellType:"1",
					cellVal:"240040043.08"
				},
			},{
				title: "",
				grade:'',
				disabledcwbbyzx_0_x_1:true,
				disabledcwbbyzx_0_x_2:true,
				cwbbyzx_0_x_1: {cellType:"0",},
				cwbbyzx_0_x_2: {cellType:"0",},
			},{
				title: "",
				grade:'',
				disabledcwbbyzx_0_x_1:true,
				disabledcwbbyzx_0_x_2:true,
				cwbbyzx_0_x_1: {cellType:"0",},
				cwbbyzx_0_x_2: {cellType:"0",},
			},{
				title: "",
				grade:'',
				disabledcwbbyzx_0_x_1:true,
				disabledcwbbyzx_0_x_2:true,
				cwbbyzx_0_x_1: {cellType:"0",},
				cwbbyzx_0_x_2: {cellType:"0",},
			},{
				title: "",
				grade:'',
				disabledcwbbyzx_0_x_1:true,
				disabledcwbbyzx_0_x_2:true,
				cwbbyzx_0_x_1: {cellType:"0",},
				cwbbyzx_0_x_2: {cellType:"0",},
			},{
				title: "",
				grade:'',
				disabledcwbbyzx_0_x_1:true,
				disabledcwbbyzx_0_x_2:true,
				cwbbyzx_0_x_1: {cellType:"0",},
				cwbbyzx_0_x_2: {cellType:"0",},
			},{
				title: "资产总计",
				grade:'34',
				disabledcwbbyzx_0_x_1:false,
				disabledcwbbyzx_0_x_2:false,
				cwbbyzx_0_x_1: {
					cellCode:"cwbbwxz_0_34_3",
					cellType:"0",
					cellVal:"240040043.08"
				},
				cwbbyzx_0_x_2: {
					cellCode:"cwbbwxz_0_34_3",
					cellType:"0",
					cellVal:"240040043.08"
				},
			}
		]
	}
	return obj
}

